const getSelectOptions = (data: any) => {
  const selectOptions: Array<{ label: string; value: string }> =
    data &&
    data.map((item: any) => ({
      label: item.label,
      value: item.tabId
    }));

  return selectOptions || [];
};

const getI18nItems = (
  t: (key: string) => string,
  i18nKey: string
): {
  alias: string;
  id?: string;
  type?: string;
  label?: string;
  hideNavigation?: boolean;
  displaySpeakUp?: boolean;
  sections?: {
    label: string;
    anchor: string;
    icon: string;
    title: string;
    content: string;
  }[];
}[] => {
  const transValue = t(i18nKey);
  if (Array.isArray(transValue)) {
    return transValue;
  }
  return [];
};

export { getI18nItems, getSelectOptions };
